import * as React from "react"

const AllSizes = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 289.28 89.44" {...props}>
    <title>{"home-6-all-package-sizes-2"}</title>
    <circle cx={202.43} cy={44.72} r={44.72} fill="#b9d816" />
    <circle cx={268.22} cy={67.08} r={21.06} fill="#3e4c5e" />
    <path fill="#4ead90" d="m77.09 3.47-48.27 83.8h96.54L77.09 3.47z" />
    <path fill="#3e4c5e" d="M25.06 3.26 0 46.77h50.12L25.06 3.26z" />
    <path
      fill="#4ead90"
      d="m178.49 44.72-24.63 42.66h-49.25l24.63-42.66h49.25z"
    />
    <path
      fill="#3e4c5e"
      d="M104.61 2.07h49.25l24.63 42.65h-49.25L104.61 2.07z"
    />
    <path
      fill="#b9d816"
      d="M104.67 2.07 80.1 44.72l24.57 42.66 24.57-42.66-24.57-42.65z"
    />
  </svg>
)

export default AllSizes
